import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton, WixIcons } from '../../../../components/common';
import { useTrackSearchAndFiltersAnalytics } from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import { ClickOriginsSearchAndFiltersClear } from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics/useTrackSearchAndFiltersAnalytics.types';
import { IOuter } from '../EmptyState.types';

export const ResetFiltersButton: FC<IOuter> = ({ clearAllExtendedFilters }) => {
  const { trackSearchAndFiltersClear } = useTrackSearchAndFiltersAnalytics();

  const handleClick = useCallback(() => {
    trackSearchAndFiltersClear(ClickOriginsSearchAndFiltersClear.Filter);
    clearAllExtendedFilters();
  }, [trackSearchAndFiltersClear, clearAllExtendedFilters]);

  return (
    <TextButton as="a" onClick={handleClick} prefixIcon={<WixIcons.Refresh />} dataHook="reset-filters-button">
      <FormattedMessage id="empty-state.reset-filters" />
    </TextButton>
  );
};
